// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $Model,
  $ModelUpsertParams,
} from 'common.data';

// Global Enums
import {
  RegattaBoatRentStatus,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  Col,
  Row,
} from 'reactstrap';
import {
  AvField,
} from 'availity-reactstrap-validation';
import {
  InputFile,
  InputNumber,
} from '@vroskus/library-components';

// Helpers
import _ from 'lodash';
import ErrorLog from '@vroskus/library-sentry/dist/browser';
import {
  regattaBoatRentStatusLabel,
} from 'common.language';
import config from '../../../config';

// Components
import InputNo from '../../form/InputNo';

// Types
type $Props = $Translate & {
  item: $Model<'RegattaBoatRent'> | $ModelUpsertParams<'RegattaBoatRent'>;
};

const RegattaBoatRentFieldsView = function ({
  item,
  t,
}: $Props) {
  return (
    <>
      <Row>
        <Col>
          <AvField
            label={t('Status')}
            name={'Status'}
            required
            type={'select'}
            value={item.Status}
          >
            {_.map(
              RegattaBoatRentStatus,
              (i) => (
                <option
                  key={i}
                  value={i}
                >
                  {t(regattaBoatRentStatusLabel[i])}
                </option>
              ),
            )}
          </AvField>
        </Col>
        <Col>
          <AvField
            label={t('Title')}
            name={'Name'}
            required
            value={item.Name}
          />
        </Col>
      </Row>
      <Row>
        <Col sm={4}>
          <InputNo
            label={t('Registration no.')}
            name={'RegistrationNo'}
            value={item.RegistrationNo}
          />
        </Col>
        <Col sm={5}>
          <InputFile
            fileDirUrl={`${config.CDN_URL}/images/max`}
            imageThumbDirUrl={`${config.CDN_URL}/images/min`}
            label={t('Image')}
            labelChangeFile={t('Change file')}
            labelError={t('Error')}
            labelFile={t('File')}
            name={'Image'}
            onError={ErrorLog.exception}
            uploadUrl={`${config.CDN_URL}/v1.0/upload/image`}
            value={item.Image}
          />
        </Col>
        <Col sm={3}>
          <InputNumber
            label={`${t('Price')} (${'Eur'})`}
            name={'Price'}
            required
            value={item.Price}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <AvField
            label={t('Email')}
            name={'Email'}
            required
            type={'email'}
            value={item.Email}
          />
        </Col>
        <Col>
          <AvField
            label={t('Phone')}
            name={'Phone'}
            value={item.Phone}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <AvField
            label={t('Description')}
            name={'Content'}
            type={'textarea'}
            value={item.Content}
          />
        </Col>
      </Row>
    </>
  );
};

export default RegattaBoatRentFieldsView;
